import React, { useEffect, useRef, useState } from 'react';
import Chart from 'react-apexcharts';
import useSidebarSubMainTab from '../../../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab';
import { createPortal } from 'react-dom';

const BarChart = ({ data, type, searchedInsuranceIDs, insurancesData, AgingDateType }) => {
  console.log('data', searchedInsuranceIDs);

  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [isHovered, setIsHovered] = useState(true);
  const hoverTimer = useRef(null); // Ref to hold the timer ID
  const openSidebarSubMainTab = useSidebarSubMainTab();
  const categories = ["1-30", "31-60", "61-90", "91-120", "121-150", "151-180", "181-210", "211-240", "241-270", "271-300", "301-330", "331-365", "Total"];
  // In Case of "Adult Day Care","Homecare Agency"
  let Data = data.filter(item => (["Adult Day Care", "Homecare Agency"].includes(item.PracticeType) ? (item.name === 'Insurance Aging' && item.group === 'Insurance Aging') : true));
  const getColor = (name) => {
    return name === "Insurance Aging" ? '#F9E10D' : '#FFF9C7'
  }
  let legendsColors = Data?.flatMap(item => item.group).map(getColor);
  // console.log("legends Colors",legendsColors)

  const options = {
    chart: {
      type: 'bar',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
      events: {
        dataPointMouseEnter: function (event, chartContext, config) {
          // console.log("dataPointMouseEnter")
          hoverTimer.current = setTimeout(() => {
            setHoveredPoint({
              position: { X: event.clientX, Y: event.clientY },
              seriesIndex: config.seriesIndex,
              dataPointIndex: config.dataPointIndex,
              w: chartContext.w,
            });
            setIsHovered(true);
          }, 50);
        },
        dataPointMouseLeave: function () {
          clearTimeout(hoverTimer.current); // Cancel the pending timeout
        },
        // click: (event, chartContext, config) => {
        //   if (type === 'Aging') {
        //     const clickedDataPointIndex = config.dataPointIndex;
        //     if(clickedDataPointIndex >= 0){
        //     // openSidebarSubMainTab('Reports-432');
        //     openSidebarSubMainTab(`Reports-432-{"Age":"${config.dataPointIndex}"}`);
        //     }
        //   }
        // },
      },
    },
    stroke: {
      colors: ["transparent"],
      width: 1
    },
    colors: legendsColors, // ✅ this sets both bar and legend marker colors
    legend: {
      position: 'top',
      horizontalAlign: 'left', // Align legend horizontally to the left
      // offsetX: 20, // Adjust X offset as needed
      offsetY: 0, // Adjust Y offset as needed
      fontSize: 12,
      fontFamily: 'Poppins',
      fontWeight: '500',
      style: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '8px',
      },
      markers: {
        height: 10,
        width: 10,
      },
    },
    dataLabels: {
      enabled: false, // Set to false to hide the text labels on the bars
    },
    series: Data,
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: 12,
          fontFamily: 'Poppins',
          fontWeight: '400',
          colors: '#434343',
        },
      },
    },
    yaxis: {
      tickAmount: 3, // Adjust this number to show fewer or more y-axis points
      labels: {
        style: {
          fontSize: 12,
          fontFamily: 'Poppins',
          fontWeight: '400',
          colors: '#434343',
        },
        formatter: (val) => {
          return (`$${String(val).length < 4 ? val : String(val).length < 7 ? val / 1000 + 'K' : String(val).length >= 7 ? val / 1000000 + 'M' : val}`);
        },
      },
    },
    fill: {
      type: 'solid', // ✅ just solid fill, no custom colors here
      // colors: legendsColors,
    },
    toolbar: {
      show: false, // Set to false to hide the toolbar (options on the right side)
    },
    contextMenu: {
      menu: false, // Set to false to hide the context menu
    },
    tooltip: {
      enabled: false, // Disable the default tooltip
      intersect: true,
      shared: false,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const seriesData = w.config.series.map((item, index) => {
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2, // minimum number of fractional digits
            maximumFractionDigits: 2, // maximum number of fractional digits
          });
          let amount = item.data?.[dataPointIndex] ? formatter.format(item.data?.[dataPointIndex]) : formatter.format(0);
          return `
          <div class='d-flex justify-content-between mt-1' style = 'width: 170px;'>
          <p class='xsm_text'><span style='display: inline-block; background-color: ${getColor(item.name)};  width: 6px; height: 6px; border-radius: 3px ; margin-right: 5px;' ></span>${item.name}</p> 
          <p class='xsm_text'> ${amount}
          </div>`
        });
        return `
        <div class="apexcharts-tooltip-title pt-0 mt-0">
          <p class='xsm_heading app_border py-2 text-center border-end-0 border-start-0 border-top-0'>Age ${w.globals.labels[dataPointIndex]}</p>
          <div className='content'> ${seriesData.join('')}</div>
        </div>
        `;
      },
    },
  };

  const [state, setState] = useState(options);

  return (
    <>
    <div style={{ width: '100%' }}>
      <Chart
        options={state}
        series={state?.series}
        type={state.chart.type}
        height="206"
      />
      </div>
      {hoveredPoint && isHovered && hoveredPoint.seriesIndex !== -1 && (
        createPortal(
          <CustomTooltip
            position={hoveredPoint.position}
            series={state.series}
            seriesIndex={hoveredPoint.seriesIndex}
            dataPointIndex={hoveredPoint.dataPointIndex}
            w={hoveredPoint.w}
            setHoveredPoint={setHoveredPoint}
            isHovered={isHovered}
            setIsHovered={setIsHovered}
            AgingDateType={AgingDateType}
            searchedInsuranceIDs={searchedInsuranceIDs}
            insurancesData={insurancesData}
            getColor={getColor}
            categories={categories}
          // months={months}
          />,
          document.getElementById('root') // Render to the root
        )
      )}
    </>
  );
};

export default BarChart;

const CustomTooltip = ({ position, series, seriesIndex, dataPointIndex, w, setHoveredPoint, isHovered, setIsHovered, AgingDateType, months, searchedInsuranceIDs, insurancesData, getColor, categories }) => {
  // console.log("series",series)
  const openSidebarSubMainTab = useSidebarSubMainTab();
  const [isOverflowedY, setIsOverflowedY] = useState(false);
  const [isOverflowedX, setIsOverflowedX] = useState(false);

  const checkTooltipOverflow = () => {
    const tooltip = document.getElementById('tooltip');
    const rect = tooltip.getBoundingClientRect();
    // console.log(rect)
    setIsOverflowedY(rect.bottom > window.innerHeight);
    setIsOverflowedX(rect.right > window.innerWidth);

  };

  useEffect(() => {
    checkTooltipOverflow();
    window.addEventListener('resize', checkTooltipOverflow);
    return () => window.removeEventListener('resize', checkTooltipOverflow);
  }, []);
  // console.log("position", position)

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  // let totalAmt = w.config.series.map((item) => { return item.data?.[dataPointIndex]
  //   ? formatter.format(item.data[dataPointIndex])
  //   : formatter.format(0); });

  const totalAmount = w.config.series.reduce((sum, currSeries) => {
    return sum + (currSeries?.data?.[dataPointIndex] || 0);
  }, 0);
  let totalAmountFrmtd = totalAmount
    ? formatter.format(totalAmount)
    : formatter.format(0);

  const handleNavigate = (name) => {
    let idx = categories.findIndex(it => it === w.globals.labels[dataPointIndex]);
    let componentID = name === "Patient Aging" ? 434 : name === "Insurance Aging" ? 432 : 432;
    console.log("componentID", componentID)
    openSidebarSubMainTab(`Reports-${componentID}-{"DateType":"${AgingDateType}","Age":"${idx}" ,"InsuranceID":"${searchedInsuranceIDs}"}`);
    handleClose();
  };
  const seriesData = w.config.series.map((item, index) => {
    // console.log("item", item)
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    // let amount = item.data?.[dataPointIndex]
    // ? formatter.format(item.data[dataPointIndex])
    // : formatter.format(0);

    let insuranceData = insurancesData?.[`${dataPointIndex}`] || [];
    const monthName = months?.[dataPointIndex] || 'Unknown';
    // console.log("monthName", monthName)
    // console.log("monthNamew", w.globals.labels[dataPointIndex])
    let amounts = item.data?.[dataPointIndex]
      ? formatter.format(item.data[dataPointIndex])
      : formatter.format(0);
    // const totalAmount = series.reduce((sum, currSeries) => {
    //     return sum + (currSeries[dataPointIndex] || 0);
    // }, 0);
    // const formattedTotal = formatter.format(totalAmount);
    // return row.join('');
    // if (item.name === 'Charges') {
    // } else {

    // w.globals.labels[dataPointIndex]
    // console.log("insuranceDataindex",index)
    // console.log("insuranceData",insuranceData,amounts, typeof amounts)
    return (<>
      {
        // Number(item.data?.[dataPointIndex]) > 0 &&
        (<>
          {index === 0 &&
            (<div
              key={index}
              className="px-10 pt-2 pb-2px br-bottom-1 br-light d-flex justify-content-between align-items-center"
            >
              <p className='xsm_heading'>Age {w.globals.labels[dataPointIndex]}</p>
              <p className='xsm_heading'>{totalAmountFrmtd}</p>
            </div>)}
          {/* {insuranceData?.map(it => { 
        let amount = it.Amount ? formatter.format(it.Amount) : formatter.format(0);
        return ( */}
          <>
            <div
              key={index}
              className='d-flex justify-content-between mt-1 ar-financial-tooltip-popup px-10'
              style={{ width: '210px' }}
            >
              <p className='xsm_text'>
                <span
                  style={{
                    display: 'inline-block',
                    backgroundColor: getColor(item.name),
                    width: '6px',
                    height: '6px',
                    borderRadius: '3px',
                    marginRight: '5px',
                  }}
                ></span>
                {item.name}
              </p>
              <p className='xsm_text ammount-text cursor-pointer' onClick={
                // () =>{handleNavigate(it.InsuranceID);}
                () => { handleNavigate(item.name) }
              }>{amounts}</p>
            </div>
          </>
          {/* );
      })} */}
        </>)}
    </>
    )
    // }
  });
  // console.log("isHovered", isHovered)
  const handleClose = () => {
    setIsHovered(false);
    setHoveredPoint(null);
  }
  return (
    // <CustomUseRef onClose={handleClose} IsActivePtPayments={false}>
    <div
      id="tooltip" className={`apexcharts-tooltip-title ar-apexcharts-tooltip-title p-0 mb-0 ${isOverflowedY ? 'flip' : ''} ${isOverflowedX ? 'flipX' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { handleClose(); }}
      style={{
        display: isHovered ? 'block' : 'none', position: 'absolute', // Absolute positioning
        top: `${position.Y - 44}px`,
        left: `${position.X - 15}px`,
        zIndex: "100",
        transition: ".15s ease all",
        opacity: 0,
      }}
    >
      <div className='content'>{seriesData}</div>
    </div>

  );
};